export const getTranslations = t => {
  return {
    orLabel: t("kf.global.label.or"),
    titleLabel: t("kf.express.label.title"),
    messageLabel: t("kf.express.label.message"),
  }
}
